import Navbar from "@Components/navbar";
import { PlayIcon } from "@assets/index";
import { UploadIcon } from "@radix-ui/react-icons"
import AutomationTable from "./components/AutomationTable";
import { useCreateAutomationMutation, useDeleteAutomationMutation, useLazyGetAutomationsQuery } from "./apiSlice";
import { useEffect, useState } from "react";
import ReactModal from 'react-modal';
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "@Constants/routes";


import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@Components/shadcn/ui/pagination"
import { displayToast } from "@Utils/toast";
import Loader from "@Components/Loader";
import posthog from "posthog-js";
import { AnalyticsParamBuilder, useUpgradeContext } from "@Utils/common";
import { RootState, useAppSelector } from "@Store/store";
import UserInputsModal from "./components/UserInputsModal";


const COMPONENT = "automations_list";

const AutomationList = () => {

  const [AutomationsData, setAutomationsData] = useState<any>({})

  const [getAutomation, { data: automationData, error: automationErr, isFetching: isAutomationLoading }] = useLazyGetAutomationsQuery()
  let [createNewAutomation, { data: createAutomationData, error: createAutomationError, isLoading: isCreateAutomationLoading }] = useCreateAutomationMutation()
  let [DeleteAutomation, { data: DeleteAutomationData, error: DeleteAutomationError, isLoading: isDeleteAutomationLoading }] = useDeleteAutomationMutation()

  const [editAutomationModal, setEditAutomationModal] = useState(false)
  const [EditAutomationModalData, setEditAutomationModalData] = useState({})
  const [deleteAutomationModal, setDeleteAutomationModal] = useState(false)
  const [DeleteAutomationModalData, setDeleteAutomationModalData] = useState(-1)
  const [leadsModalOpen, setLeadsModalOpen] = useState(false);
  const [selectedAutomationId, setSelectedAutomationId] = useState<number | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();


  const { setUpgradeToPro } = useUpgradeContext();

  const { user } = useAppSelector((state: RootState) => state.profile);
  const selectedIgData = useAppSelector((state: RootState) => state.igSelection.selectedIgData);
  const ig_user = selectedIgData


  // Get initial values from URL params or use defaults
  const getInitialPageLimit = () => {
    const len = searchParams.get('len');
    return len ? parseInt(len) : 10;
  };

  const getInitialPageNumber = () => {
    const page = searchParams.get('page');
    return page ? parseInt(page) : 1;
  };

  const [pageLimit, setPageLimit] = useState(getInitialPageLimit())
  const [pageNumber, setPageNumber] = useState(getInitialPageNumber())
  const [DeleteAutomationId, setDeleteAutomationId] = useState(-1)

  const navigate = useNavigate();

  const closeEditAutomationModal = () => {
    setEditAutomationModal(!editAutomationModal)
  }

  const openEditAutomationModal = (contact_index: number) => {
    setEditAutomationModalData(automationData?.data[contact_index])
    setEditAutomationModal(!editAutomationModal)
  }


  const closeDeleteAutomationModal = () => {
    posthog.capture("ui_close", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "modal",
      classValue: "delete_automation",
      int_value: DeleteAutomationId
    }));
    setDeleteAutomationModal(!DeleteAutomationModal)
  }

  const openDeleteAutomationModal = (automation_id: number) => {
    setDeleteAutomationId(automation_id)
    setDeleteAutomationModal(!editAutomationModal)
  }

  const deleteAutomationButtonClick = (e: any) => {
    DeleteAutomation(DeleteAutomationId)
    setDeleteAutomationModal(!DeleteAutomationModal)
  }

  const openLeadsModal = (automation_id: number) => {
    setSelectedAutomationId(automation_id);
    setLeadsModalOpen(true);
  }

  const closeLeadsModal = () => {
    setLeadsModalOpen(false);
    setSelectedAutomationId(null);
  }

  // Sync state with URL params when they change
  useEffect(() => {
    const len = searchParams.get('len');
    const page = searchParams.get('page');

    if (len && parseInt(len) !== pageLimit) {
      setPageLimit(parseInt(len));
    }
    if (page && parseInt(page) !== pageNumber) {
      setPageNumber(parseInt(page));
    }
  }, [searchParams]);

  useEffect(() => {
    document.title = "LinkPlease - Dashboard | Automation List";

    getAutomation({
      limit: pageLimit,
      page: pageNumber,
      ig_id: ig_user?.igsid,
    })

  }, [])


  useEffect(() => {
    if (deleteAutomationModal) {
      posthog.capture("ui_view", AnalyticsParamBuilder({
        kingdom: COMPONENT,
        phylum: "modal",
        classValue: "delete_automation",
        int_value: DeleteAutomationId
      }));
    }
  }, [deleteAutomationModal])



  useEffect(() => {
    if (automationData?.data?.automations) setAutomationsData(automationData);
    if (automationErr) console.error(automationErr);
  }, [automationData])



  useEffect(() => {
    getAutomation({
      limit: pageLimit,
      page: pageNumber,
      ig_id: ig_user?.igsid,
    })
  }, [pageLimit, pageNumber, DeleteAutomationData])

  useEffect(() => {
    if (DeleteAutomationData) {
      displayToast('success', DeleteAutomationData?.message || 'Automation Deleted Successful')
    }

    if (DeleteAutomationError) {
      console.error(DeleteAutomationError);
      displayToast('error', DeleteAutomationError?.data?.message || 'Automation Deletion Unsuccessful')
    }

  }, [DeleteAutomationData, DeleteAutomationError])


  const addAutomationButtonClick = (e: any) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "create_automation",
      classValue: "add_button"
    }));

    createNewAutomation({
      ig_id: ig_user?.igsid
    })
  }

  const handlePageLimitChange = (e: any) => {
    if (e?.target?.name == 'pageLimit') {
      const newLimit = parseInt(e?.target?.value);

      // Track analytics
      posthog.capture("ui_action", AnalyticsParamBuilder({
        kingdom: COMPONENT,
        phylum: "pagination_limit_change",
        int_value: newLimit,
        str_value: `${pageLimit}_to_${newLimit}`
      }));

      setPageNumber(1)
      setPageLimit(newLimit)

      // Update URL params
      const newParams = new URLSearchParams(searchParams);
      newParams.set('len', newLimit.toString());
      newParams.set('page', '1');
      setSearchParams(newParams);
    }
  }

  const handlePageNumberChange = (type: number) => {
    let newPageNumber = pageNumber;
    if (type === -1) newPageNumber = pageNumber - 1;
    if (type === 1) newPageNumber = pageNumber + 1;

    // Track analytics
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "pagination_page_change",
      int_value: newPageNumber,
      str_value: type === -1 ? "previous" : "next"
    }));

    setPageNumber(newPageNumber);

    // Update URL params
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', newPageNumber.toString());
    newParams.set('len', pageLimit.toString());
    setSearchParams(newParams);
  }

  useEffect(() => {

    if (createAutomationData) {
      posthog.capture("new_automation", AnalyticsParamBuilder({
        kingdom: COMPONENT,
        phylum: "create_automation",
        classValue: "successful",
        genus: 'redirect',
        int_value: createAutomationData?.data?.automation_id,
      }));
      navigate(ROUTES.FLOW_BUILDER.replace(':automation_doc_id', createAutomationData?.data?.automation_id))
    }


  }, [createAutomationData, createAutomationError])

  const refreshAutomation = () => {
    getAutomation({
      limit: pageLimit,
      page: pageNumber
    })
  }

  const OnClickUpgrade = (from: string) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "on_upgrade_click",
      classValue: from,
    }));
    if (user?.status == "pending") {
      displayToast("error", "Your Subscription payment is Pending! Contact Support ASAP");
      return
    }
    setUpgradeToPro(true)
  }



  return (
    <div className="min-h-screen bg-gray-50/50 p-4 md:p-8">
      {/* Header Section */}
      <div className="max-w-7xl mx-auto mb-8 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight">Automations</h1>
        </div>

        <div className="flex items-center gap-2 md:gap-4">
          <button
            onClick={addAutomationButtonClick}
            className="inline-flex items-center justify-center gap-2 bg-[#3535d5] hover:bg-[#2b2bb8] text-white px-5 py-2.5 rounded-xl font-medium transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="size-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Create
          </button>
        </div>
      </div>


      <div className="max-w-7xl mx-auto md:bg-white md:rounded-2xl md:shadow-sm md:border md:border-gray-100 overflow-hidden">
        {isAutomationLoading ? (
          <div className="p-8"><Loader isLoading={true} /></div>
        ) : (
          <AutomationTable
            data={AutomationsData?.data?.automations}
            openDeleteAutomationModal={openDeleteAutomationModal}
            fetchAutomations={refreshAutomation}
            openLeadsModal={openLeadsModal}
            onCreateAutomation={addAutomationButtonClick}
          />
        )}

        <div className="p-4 md:border-t md:border-gray-100 md:bg-gray-50/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center text-sm text-gray-500">
              <span className="mr-2">Rows per page:</span>
              <select
                className="bg-transparent font-medium text-gray-900 outline-none cursor-pointer focus:ring-2 focus:ring-blue-500 rounded px-1"
                name="pageLimit"
                onChange={handlePageLimitChange}
                value={pageLimit}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            <Pagination className="mx-0 w-auto">
              <PaginationContent>
                {pageNumber !== 1 && (
                  <PaginationItem className="cursor-pointer" onClick={() => handlePageNumberChange(-1)}>
                    <PaginationPrevious />
                  </PaginationItem>
                )}

                <PaginationItem>
                  <PaginationLink isActive className="bg-[#3535d5] hover:bg-[#2b2bb8] text-white border-transparent">{pageNumber}</PaginationLink>
                </PaginationItem>

                {pageLimit * pageNumber < (automationData?.data?.totalCount || 0) && (
                  <PaginationItem className="cursor-pointer" onClick={() => handlePageNumberChange(1)}>
                    <PaginationNext />
                  </PaginationItem>
                )}
              </PaginationContent>
            </Pagination>
          </div>
        </div>
      </div>

      <DeleteAutomationModal
        isModalOpen={deleteAutomationModal}
        editAutomationModalOnClose={closeDeleteAutomationModal}
        deleteAutomation={deleteAutomationButtonClick}
        deleteAutomationId={DeleteAutomationId}
      />
      <UserInputsModal isOpen={leadsModalOpen} onClose={closeLeadsModal} automationId={selectedAutomationId} />
    </div>
  );
};

interface EditAutomationModalInterface {
  isModalOpen: boolean;
  editAutomationModalOnClose: () => void;
}



interface DeleteAutomationModalInterface {
  isModalOpen: boolean;
  editAutomationModalOnClose: () => void;
  deleteAutomation: (e: any) => void;
  deleteAutomationId: number
}


const DeleteAutomationModal = (props: DeleteAutomationModalInterface) => {

  const OnCancelClick = () => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "modal",
      classValue: "cancel_button",
      int_value: props.deleteAutomationId
    }));
    props.editAutomationModalOnClose()
  }

  const OnDeleteClick = () => {
    props.deleteAutomation(props.deleteAutomationId)
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "modal",
      classValue: "delete_button",
      int_value: props.deleteAutomationId
    }));
  }

  return (
    <ReactModal
      isOpen={props.isModalOpen}
      onRequestClose={props.editAutomationModalOnClose}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: '16px',
          padding: '24px',
          border: 'none',
          maxWidth: '400px',
          width: '90%',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 50,
          backdropFilter: 'blur(4px)'
        }
      }}
      portalClassName={"ReactModalPortal"}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      role={"dialog"}
      preventScroll={false}
    >
      <div className="flex flex-col h-full">
        <div className="mb-4">
          <h3 className="text-xl font-bold text-gray-900">Delete Automation</h3>
        </div>

        <div className="mb-8">
          <p className="text-gray-600 leading-relaxed">
            Are you sure you want to delete this automation? This action cannot be undone.
          </p>
        </div>

        <div className="flex justify-end gap-3 mt-auto">
          <button
            className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 border border-gray-300 rounded-lg transition-colors outline-none focus:ring-2 focus:ring-gray-200"
            onClick={OnCancelClick}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm transition-colors outline-none focus:ring-2 focus:ring-red-200"
            onClick={OnDeleteClick}
          >
            Delete
          </button>
        </div>
      </div>
    </ReactModal>
  )
}

export default AutomationList;
